import React, { Component } from 'react'

export default class PageNotFound extends Component {
  render() {
    return (
      <div>
        <div style={{backgroundSize:"100% 100%"}} className='bg-[url(https://assets.materialup.com/uploads/a77eb3fb-a743-45af-97e1-b1a2549dd46d/preview.jpg)] bg-no-repeat h-[85vh] w-[100%] bg-contain'></div>
        {/* <img src='https://assets.materialup.com/uploads/a77eb3fb-a743-45af-97e1-b1a2549dd46d/preview.jpg' /> */}
      </div>
    )
  }
}
